module.exports = __webpack_public_path__ + "img/paas_wrapbg1.5ca9b86b.png";